module.exports = __webpack_public_path__ + "img/weather_top.8afb8aed.gif";